export const types = {
  TEXT_SECTION: 'TEXT_SECTION',
  CTA: 'CTA',
  SNIPPET_SECTION: 'SNIPPET_SECTION',
  SHARED_COMPONENT: 'SHARED_COMPONENT',
  INTERACTIVE_HOME_PARTNERS_SECTION: 'INTERACTIVE_HOME_PARTNERS_SECTION',
  INTERACTIVE_MAP: 'INTERACTIVE_MAP',
};

export default (content = {}) => {
  if (!content) return null;

  if (
    content?.ctaHeader ||
    content?.ctaSubHeader ||
    content?.ctaIntro ||
    content?.ctaLinks
  )
    return types.CTA;
  if (
    content?.snippetSectionHeader ||
    content?.snippets?.length ||
    content?.snippetLayout
  )
    return types.SNIPPET_SECTION;
  if (content?.component) return types.SHARED_COMPONENT;
  if (content?.logos) return types.INTERACTIVE_HOME_PARTNERS_SECTION;
  if (
    content?.sectionLabel ||
    content?.sectionSubHeader ||
    content?.sectionHeader ||
    content?.sectionIntro
  )
    return types.TEXT_SECTION;
  if (
    content?.mapSectionHeader ||
    content?.mapLevel ||
    content?.licenseStateColor ||
    content?.selectedStateColor ||
    content?.stateBorderColor ||
    content?.mapBackgroundColor
  )
    return types.INTERACTIVE_MAP;
  return null;
};
